// extracted by mini-css-extract-plugin
export default {"promo-grid":"_dkpa0k","promoGrid":"_dkpa0k","promo-carousel":"_z6z4zy","promoCarousel":"_z6z4zy"};